import { postApi } from "./api_instance";

export const depositAmount = async (amount, dispatch) => {
  try {
    const { data } = await postApi({
      apiUrl: `/payments/api/wallet/deposit-request?amount=${amount}`,
      sendToken: true,
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
